import { Contract } from '@/types'
import { router } from '@inertiajs/react'
import { useState } from 'react'
import { toast } from 'react-hot-toast'

// Downloading and emailing a recap work the same from the list and from a single société's page,
// including the prompt that replaces the send when the contract has no email address.
export function useRecapActions(organizationSlug: string | undefined, month: string) {
  const [sendingContractId, setSendingContractId] = useState<number | null>(null)
  const [missingEmailContract, setMissingEmailContract] = useState<Contract | null>(null)

  const closeMissingEmail = () => setMissingEmailContract(null)

  const downloadPdf = (contract: Contract) => {
    window.location.href = `/organizations/${organizationSlug}/recap_pdfs/${contract.id}?month=${month}`
  }

  const sendEmail = (contract: Contract) => {
    if (!contract.customer_email) {
      setMissingEmailContract(contract)
      return
    }

    if (!confirm(`Envoyer le récapitulatif par email à ${contract.customer_email} ?`)) return

    setSendingContractId(contract.id)
    router.post(
      `/organizations/${organizationSlug}/recap_emails`,
      { contract_id: contract.id, month },
      {
        preserveScroll: true,
        preserveState: true,
        onError: () => toast.error("L'envoi du récapitulatif par email a échoué."),
        onFinish: () => setSendingContractId(null),
      },
    )
  }

  return { sendingContractId, missingEmailContract, closeMissingEmail, downloadPdf, sendEmail }
}
